/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activate_SuccessInputs */



/**
* | output |
* | --- |
* | "Your subscription has been activated successfully." |
*
* @param {Activate_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const activate_success = /** @type {((inputs?: Activate_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activate_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre abonnement a été activé avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Abonnement wurde erfolgreich aktiviert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tuo abbonamento è stato attivato con successo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ваша подписка успешно активирована.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su suscripción ha sido activada exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您的订阅已成功激活。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションが正常に有効化されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपकी सदस्यता सफलतापूर्वक सक्रिय हो गई है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sua assinatura foi ativada com sucesso.")
	return /** @type {LocalizedString} */ ("Your subscription has been activated successfully.")
});